import axios from 'axios';
import {base_api} from './base';

export function getLoggedUser(username) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Users/GetByName?name=${username}`, {headers});
}

export function getUserById(id) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Users/GetById?id=${id}`, {headers});
}

export function getUsersByCompanyId(companyId) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Users/GetByCompanyId?companyId=${companyId}`, {headers});
}

export function getAllUsers(includeDeleted) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.get(`${base_api}/Users?includeDeleted=${includeDeleted}`, {headers});
}

export function addUser(data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.post(`${base_api}/Users/AddUser`, data, {headers});
}

export function updateUser(userId, data) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  return axios.put(`${base_api}/Users/UpdateUser?userId=${userId}`, data, {headers});
}

export function deleteUser(userId, hardDelete) {
  const headers = {Authorization: `Bearer ${localStorage.getItem('authToken')}`};
  let link = `${base_api}/Users/DeleteUser?userId=${userId}&hardDelete=${hardDelete}`;
  return axios.delete(link, {headers});
}



// WEBPACK FOOTER //
// ./src/services/User.service.js